import { render } from "./HomeProjects.vue?vue&type=template&id=1ba7b1b8&scoped=true"
import script from "./HomeProjects.vue?vue&type=script&lang=js"
export * from "./HomeProjects.vue?vue&type=script&lang=js"

import "./HomeProjects.vue?vue&type=style&index=0&id=1ba7b1b8&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba7b1b8"]])

export default __exports__